import { ItemAttachment, Relationship, PageInfo } from "./commonModules";

import ChangePage from "@/views/model/change/changePage.vue"; //变更页
// import ChangeTitleBlock from '@/views/model/change/changeTitleBlock.vue' //变更页
import ChangeAffectedItem from "@/views/model/change/changeAffectedItem.vue"; //变更页
import ChangeWorkflow from "@/views/model/change/changeWorkflow.vue"; //变更页
import ChangeHistory from "@/views/model/change/changeHistory.vue"; //变更页

export const Change = {
  path: "/changePage",
  component: ChangePage,
  children: [
    {
      path: "/changeTitleBlock",
      component: PageInfo,
      meta: {},
    },
    {
      path: "/changeAffectedItem",
      component: ChangeAffectedItem,
      meta: {},
    },
    {
      path: "/changeWorkflow",
      name: "changeWorkflow",
      component: ChangeWorkflow,
    },
    {
      path: "/changeAttachment",
      name: "changeAttachment",
      component: ItemAttachment,
    },
    {
      path: "/changeAttachment2",
      name: "changeAttachment2",
      component: ItemAttachment,
    },
    {
      path: "/changeRelationship",
      // name: 'changeRelationship',
      component: Relationship,
    },
    {
      path: "/changeHistory",
      name: "changeHistory",
      component: ChangeHistory,
    },
  ],
};
